import { render, staticRenderFns } from "./TextToPayDashboard.vue?vue&type=template&id=401406f0&"
import script from "./TextToPayDashboard.vue?vue&type=script&lang=js&"
export * from "./TextToPayDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports